import { LottoGame, LottoResultResponse, LottoGameBuyResponse } from "../class";

export function createLottoGameBuyResponseNotDraw(
  game: LottoGame
): LottoGameBuyResponse {
  const response = new LottoGameBuyResponse();

  response.drwNo = game.drwNo;
  //   response.drwNoDate = result.drwNoDate ?? "";
  response.drwtNo1 = game.drwtNo1;
  response.drwtNo2 = game.drwtNo2;
  response.drwtNo3 = game.drwtNo3;
  response.drwtNo4 = game.drwtNo4;
  response.drwtNo5 = game.drwtNo5;
  response.drwtNo6 = game.drwtNo6;
  response.buyType = game.buyType ?? "TERRA";

  return response;
}
export function createLottoGameBuyResponse(
  game: LottoGame,
  result: LottoResultResponse
): LottoGameBuyResponse {
  const response = new LottoGameBuyResponse();

  response.drwNo = game.drwNo;
  response.drwNoDate = result.drwNoDate ?? "";
  response.drwtNo1 = game.drwtNo1;
  response.drwtNo2 = game.drwtNo2;
  response.drwtNo3 = game.drwtNo3;
  response.drwtNo4 = game.drwtNo4;
  response.drwtNo5 = game.drwtNo5;
  response.drwtNo6 = game.drwtNo6;
  response.buyType = game.buyType ?? "TERRA";
  response.createDatetime = new Date().toISOString();

  // 각 번호에 대해 일치 여부 표시
  response.winDrwtNo1 = checkWinningNumber(game.drwtNo1, result);
  response.winDrwtNo2 = checkWinningNumber(game.drwtNo2, result);
  response.winDrwtNo3 = checkWinningNumber(game.drwtNo3, result);
  response.winDrwtNo4 = checkWinningNumber(game.drwtNo4, result);
  response.winDrwtNo5 = checkWinningNumber(game.drwtNo5, result);
  response.winDrwtNo6 = checkWinningNumber(game.drwtNo6, result);

  // 등수 계산
  response.rank = calculateRank(game, result);

  // 상금 계산
  response.prize = calculatePrize(response.rank, result);

  return response;
}

function checkWinningNumber(num: number, result: LottoResultResponse): number {
  if (num === result.bnusNo) return 2; // 보너스 번호
  const winNumbers = [
    result.drwtNo1,
    result.drwtNo2,
    result.drwtNo3,
    result.drwtNo4,
    result.drwtNo5,
    result.drwtNo6,
  ];
  return winNumbers.includes(num) ? 1 : 0;
}

function calculateRank(game: LottoGame, result: LottoResultResponse): number {
  const userNums = [
    game.drwtNo1,
    game.drwtNo2,
    game.drwtNo3,
    game.drwtNo4,
    game.drwtNo5,
    game.drwtNo6,
  ];
  const winNums = [
    result.drwtNo1,
    result.drwtNo2,
    result.drwtNo3,
    result.drwtNo4,
    result.drwtNo5,
    result.drwtNo6,
  ];
  const matched = userNums.filter((n) => winNums.includes(n)).length;
  const hasBonus = userNums.includes(result.bnusNo);

  if (matched === 6) return 1;
  if (matched === 5 && hasBonus) return 2;
  if (matched === 5) return 3;
  if (matched === 4) return 4;
  if (matched === 3) return 5;
  return 6; // 미당첨
}

function calculatePrize(rank: number, result: LottoResultResponse): number {
  switch (rank) {
    case 1:
      return result.firstWinamnt ?? 0;
    case 4:
      return 50000;
    case 5:
      return 5000;
    default:
      return 0;
  }
}

export function getNowDrawNo(): number {
  return getLottoRoundByDate(new Date());
}

function getLottoRoundByDate(inputDate: Date): number {
  const BASE_ROUND = 1166;
  const BASE_DATE = new Date("2025-04-05T20:40:00"); // 기준: 1166회차 발표 시간
  const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000;

  const diffTime = inputDate.getTime() - BASE_DATE.getTime();
  const weekOffset = Math.ceil(diffTime / MS_PER_WEEK);

  return BASE_ROUND + weekOffset;
}
